module.exports = __webpack_public_path__ + "img/planet.f53b3887.png";